import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from 'components';

const Home = lazy(() => import('pages/Home'));
const NotFound = lazy(() => import('pages/NotFound'));
const Terms = lazy(() => import('pages/static/Terms'));
const Privacy = lazy(() => import('pages/static/Privacy'));
const Login = lazy(() => import('pages/auth/Login'));
const Profile = lazy(() => import('pages/user/Profile'));
const ThreadHome = lazy(() => import('pages/tread/Home'));
class Scroll extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

Scroll.propTypes = {
  location: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

const ScrollToTop = withRouter(Scroll);

class RouterComponent extends React.Component {
  render() {
    return (
      <Router>
        <ScrollToTop>
          <Switch>
            <Route
              exact
              path="/"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <Home {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/terms"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <Terms {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/privacy"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <Privacy {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/join"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <Login {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/profile"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <Profile {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/t/tread"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <ThreadHome {...props} />
                </Suspense>
              )}
            />

            <Route
              path="*"
              render={props => (
                <Suspense fallback={<Loader />}>
                  <NotFound {...props} />
                </Suspense>
              )}
            />
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

export default RouterComponent;
